import {
  FieldCategory,
  FieldValueType,
} from "@safetyculture/s12-apis-connect-web/s12/typefield/v1/field_pb";
import { FieldStatus } from "@safetyculture/s12-apis-connect-web/s12/users/userfield/v1/field_pb";

export const mapFieldDataType = (fieldType: FieldValueType): string => {
  switch (fieldType) {
    case FieldValueType.MONEY:
      return "Money";
    case FieldValueType.SELECT:
      return "Select";
    case FieldValueType.MULTI_SELECT:
      return "Multi-select";
    case FieldValueType.USER_ID:
      return "User";
    case FieldValueType.STRING:
      return "Text";
    case FieldValueType.TIMESTAMP:
      return "Date";
    case FieldValueType.TEMPLATE_ID:
      return "Template";
    case FieldValueType.SITE:
      return "Site";
    case FieldValueType.MULTI_SITE:
      return "Multi-site";
    case FieldValueType.INTEGER:
      return "Integer";
    case FieldValueType.ADDRESS:
      return "Address";
    case FieldValueType.TIMEZONE:
      return "Timezone";
    case FieldValueType.CONTACT_DETAILS:
      return "Contact details";
    default:
      return "Unspecified";
  }
};

// Status "views" — single-select, defaults to ENABLED.
export const FIELD_STATUS_OPTIONS: ReadonlyArray<{
  value: FieldStatus;
  label: string;
}> = [
  { value: FieldStatus.ENABLED, label: "Enabled" },
  { value: FieldStatus.DISABLED, label: "Disabled" },
  { value: FieldStatus.UNSPECIFIED, label: "All" },
];

// Field category — single-select. UNSPECIFIED returns both system & custom.
export const FIELD_CATEGORY_OPTIONS: ReadonlyArray<{
  value: FieldCategory;
  label: string;
}> = [
  { value: FieldCategory.UNSPECIFIED, label: "All" },
  { value: FieldCategory.SYSTEM_FIELD, label: "System" },
  { value: FieldCategory.CUSTOM_FIELD, label: "Custom" },
];

// Data types — multi-select. Empty selection returns all types.
export const SELECTABLE_DATA_TYPES: readonly FieldValueType[] = [
  FieldValueType.STRING,
  FieldValueType.INTEGER,
  FieldValueType.MONEY,
  FieldValueType.TIMESTAMP,
  FieldValueType.SELECT,
  FieldValueType.MULTI_SELECT,
  FieldValueType.USER_ID,
  FieldValueType.SITE,
  FieldValueType.MULTI_SITE,
  FieldValueType.ADDRESS,
  FieldValueType.TIMEZONE,
  FieldValueType.CONTACT_DETAILS,
  FieldValueType.TEMPLATE_ID,
];

export const dataTypeDisplayNames: Record<FieldValueType, string> =
  SELECTABLE_DATA_TYPES.reduce(
    (acc, type) => ({ ...acc, [type]: mapFieldDataType(type) }),
    {} as Record<FieldValueType, string>,
  );
